/**
 * Per-browser on/off switches for proof-of-concept features deployed to a dev environment.
 * A POC is on only when this browser has opted in, so anyone who never visits the POCs page
 * sees standard staff-fe. Each switch lives in localStorage under its own key.
 */
const STORAGE_KEY_PREFIX = 'staff-poc:';
// The `storage` event only fires in *other* tabs, so same-tab changes announce themselves too.
const CHANGE_EVENT = 'staff-poc-change';

const storageKey = (pocKey) => `${STORAGE_KEY_PREFIX}${pocKey}`;

export const isPocEnabled = (pocKey) => {
  try {
    return window.localStorage.getItem(storageKey(pocKey)) === 'on';
  } catch {
    return false;
  }
};

export const setPocEnabled = (pocKey, enabled) => {
  try {
    if (enabled) {
      window.localStorage.setItem(storageKey(pocKey), 'on');
    } else {
      window.localStorage.removeItem(storageKey(pocKey));
    }
  } catch {
    return;
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

export const subscribeToPocChanges = (onChange) => {
  window.addEventListener('storage', onChange);
  window.addEventListener(CHANGE_EVENT, onChange);
  return () => {
    window.removeEventListener('storage', onChange);
    window.removeEventListener(CHANGE_EVENT, onChange);
  };
};
